import React, {Component} from 'react';
import '../../style.css';
import {fetchPost,fetchPostFile} from "../../static/util/fetch";
import {
    Button,
    message,
    Space,
    Input,
    Card,
    Table,
    Typography,
    DatePicker,
    PageHeader,
    Menu, Modal, Form, Tag
} from "antd";
import {UploadOutlined,EditOutlined,MailOutlined} from "@ant-design/icons";
import moment from "moment";
import FileViewer from 'react-file-viewer';
const { Column } = Table;
const { Paragraph } = Typography;
const { TextArea } = Input;
class ProjectReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabBar: '1',
            project:[],
            projectData:[
                {
                    projectId:'',
                    companyName:'',
                    projectName:'',
                    projectCode: "A001",
                    department:"",
                    person: "",
                    startTime: "2020-09-01",
                    endTime: "2011-03-10",
                    time: "2020年03月18日",
                    parameter1: "这是参数1",
                    parameter2: "这是参数2",
                    parameter3: "这是参数3",
                    parameter4: "这是参数4",
                    parameter5: "这是参数5",
                    parameter6: "这是参数6",
                    parameter7: "这是参数7",
                    parameter8: "这是参数8",
                    parameter9: "这是参数9",
                    parameter10: "这是参数10",
                    parameter11: "这是参数11",
                    parameter12: "这是参数12",
                    parameter13: "",
                    parameter14: "",
                    parameter15: "这是参数15",
                    parameter16: "这是参数16",
                    parameter17: "这是参数17",
                    parameter18: "这是参数18",
                    parameter19: "这是参数19",
                    parameter20: "这是参数20",
                    parameter21: "这是参数21",
                    parameter22: "这是参数22",
                }
            ],
            projectId:0,
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            projectName:'',
            projectCode: "A001",
            department:"",
            person: "",
            startTime: "2020-09-01",
            endTime: "2011-03-10",
            time: "2020年03月18日",
            parameter1: "",
            parameter2: "",
            parameter3: "",
            parameter4: "",
            parameter5: "",
            parameter6: "",
            parameter7: "",
            parameter8: "",
            parameter9: "",
            parameter10: "",
            parameter11: "",
            parameter12: "",
            parameter13: "",
            parameter14: "",
            parameter15: "",
            parameter16: "",
            parameter17: "",
            parameter18: "",
            parameter19: "",
            parameter20: "",
            parameter21: "",
            parameter22: "",
            edit_visible:false,
            status:false,
            fileField:[],
            fileStream:'',
            upload_visible:false,
            uploadFile_visible:false,
            checkStatus:false,
            projectNameUpload:''
        }
        this.submit = this.submit.bind(this)
        this.alter = this.alter.bind(this)
    }
    componentDidMount(){
        //获取公司的所有项目名称
        fetchPost(global.constants.getBuildProjectSummaryGetG,{companyId: this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            project:res.data,
                        }))
                    }
                }
            )
    }

    handleExportClick(){
        fetchPost(global.constants.exportProjectReportI, {projectId:this.state.projectId})
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                }
            )
    }
    download(){
        let params={
            companyId:this.state.companyId,
            fileName:'2-14'+this.state.projectName+'项目研究开发设计书.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:this.state.projectId,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/2-14'+this.state.projectName+'项目研究开发设计书.doc',
                            fileName: this.state.projectName+'项目研究开发设计书.doc'
                        }
                        fetchPostFile(global.constants.downloadFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=>{
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                            let filename = '2-14'+this.state.projectName+'项目研究开发设计书.doc';//设置文件名称
                                            aElement.href = blobUrl;//设置a标签路径
                                            aElement.download = filename;
                                            document.body.appendChild(aElement);
                                            aElement.click();
                                            window.URL.revokeObjectURL(blobUrl);
                                        }
                                    )
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
        // window.open(global.constants.downloadUrl + this.state.companyName+'/2-14'+this.state.projectName+'项目研究开发设计书.docx')
    }
    handleEditClick(e){
        const value1 = e.projectId
        const value2 = e.projectName
        const value3 = e.code
        const value4 = e.startTime
        const value5 = e.endTime
        this.setState(()=>({
            edit_visible:true,
            projectId:value1,
            projectName:value2,
            projectCode:value3,
            startTime:value4,
            endTime:value5,
            tabBar:'2',
        }))
        fetchPost(global.constants.getProjectReportGetI, {projectId:e.projectId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            projectData:res.data,
                            status:true
                        }))
                    }
                    else{
                        message.info("该项目未填写立项报告，请填写").then()
                        this.setState(()=>({
                            projectData:[],
                            status:false
                        }))
                    }
                }
            )
    }
    alter(){
        fetchPost(global.constants.getProjectReportGetI, {projectId:this.state.projectId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            department: res.data.department,
                            person: res.data.person,
                            time: res.data.time,
                            parameter1: res.data.projectName,
                            parameter2:res.data.parameter2,
                            parameter3: res.data.parameter3,
                            parameter4:res.data.parameter4 ,
                            parameter5: res.data.parameter5,
                            parameter6: res.data.parameter6,
                            parameter7: res.data.parameter7,
                            parameter8: res.data.parameter8,
                            parameter9: res.data.parameter9,
                            parameter10: res.data.parameter10,
                            parameter11: res.data.parameter11,
                            parameter12: res.data.parameter12,
                            parameter13: res.data.parameter13,
                            parameter14: res.data.parameter14,
                            parameter15: res.data.parameter15,
                            parameter16: res.data.parameter16,
                            parameter17: res.data.parameter17,
                            parameter18: res.data.parameter18,
                            parameter19: res.data.parameter19,
                            parameter20: res.data.parameter20,
                            parameter21: res.data.parameter21,
                            parameter22: res.data.parameter22,
                            status:false
                        }))
                    }
                }
            )
    }
    submit(){
        if(this.state.department === ''||this.state.person === ''||this.state.time=== ''||
            this.state.parameter2 === ''||this.state.parameter3 === ''|| this.state.parameter4 === ''
            ||this.state.parameter15 === '' ||this.state.parameter16 === ''
            ||this.state.parameter17 === ''||this.state.parameter18 === '' ||this.state.parameter19 === ''
            ||this.state.parameter20 === ''||this.state.parameter21 === '' ||this.state.parameter22 === ''
        ){message.info("请检查公司信息是否填写完整").then()
        }else
        {
            let params={
                projectId:this.state.projectId,
                companyName:this.state.companyName,
                projectName:this.state.projectName,
                projectCode: this.state.projectCode,
                department: this.state.department,
                person: this.state.person,
                startTime: this.state.startTime,
                endTime: this.state.endTime,
                time: this.state.time,
                parameter1: this.state.projectName,
                parameter2:this.state.parameter2,
                parameter3: this.state.parameter3,
                parameter4:this.state.parameter4 ,
                parameter5: this.state.parameter5,
                parameter6: this.state.parameter6,
                parameter7: this.state.parameter7,
                parameter8: this.state.parameter8,
                parameter9: this.state.parameter9,
                parameter10: this.state.parameter10,
                parameter11: this.state.parameter11,
                parameter12: this.state.parameter12,
                parameter13: this.state.parameter13,
                parameter14: this.state.parameter14,
                parameter15: this.state.parameter15,
                parameter16: this.state.parameter16,
                parameter17: this.state.parameter17,
                parameter18: this.state.parameter18,
                parameter19: this.state.parameter19,
                parameter20: this.state.parameter20,
                parameter21: this.state.parameter21,
                parameter22: this.state.parameter22,
            }
            fetchPost(global.constants.addProjectReport,params)
                .then(
                    res => {
                        if(res.code === 200) {
                            message.success("添加成功").then()
                            fetchPost(global.constants.getProjectReportGetI,{projectId:this.state.projectId})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                projectData:res.data,
                                                status:true,
                                                edit_visible:false
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                )
        }
    }
    hideModal(){
        this.setState(()=>({
            upload_visible:false,
        }))
    }
    hideModalTwo(){
        this.setState(()=>({
            uploadFile_visible:false,
        }))
    }
    handleUploadClick(e){
        const value = e.projectId;
        const value1 =e.projectName
        this.setState(()=>({
            upload_visible:true,
            projectId: value,
            projectNameUpload: value1
        }))
        let params = {
            companyId:this.state.companyId,
            projectId:value,
            productId:0,
            patentId:0,
            otherId:0,
            remark:value1+'项目研究开发设计书',
            url:'',
        }
        fetchPost(global.constants.checkFile, params)
            .then(
                res => {
                    if(res.code === 200){
                        let params = {
                            companyId:this.state.companyId,
                            projectId:value,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:value1+'项目研究开发设计书',
                            url: '',
                            fileName: ''
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                checkStatus:true
                                            }))
                                        })
                                }
                            )
                    }
                    else{
                        this.setState(()=>({
                            fileStream:'',
                            checkStatus:false,
                        }))
                    }
                })
    }
    fileInput(){
        this.setState(()=>({
            fileField:document.querySelector("input[type='file'][name='file']"),
            uploadFile_visible:true,
            checkStatus:false,
        }))
    }
    uploadFile(){
        const formdata = new FormData();
        formdata.append('file', this.state.fileField.files[0]);
        formdata.append('companyId',this.state.companyId);
        formdata.append('projectId',this.state.projectId);
        formdata.append('productId',0);
        formdata.append('patentId',0);
        formdata.append('otherId',0);
        formdata.append('remark',this.state.projectNameUpload+'项目研究开发设计书');
        if (!(/pdf$/i.test(this.state.fileField.files[0].name))) {
            alert("只允许上传pdf格式的文件")
        } else{
            fetch(global.constants.uploadFile, {
                method: 'POST',
                body: formdata,
                mode: 'cors',
                credentials: 'include',
            })
                .then(res => res.json())
                .then(
                    res => {
                        if(res.code === 200){
                            message.success("上传成功").then();
                                let params = {
                                    companyId:this.state.companyId,
                                    projectId:this.state.projectId,
                                    productId:0,
                                    patentId:0,
                                    dId:0,
                                    remark:this.state.projectNameUpload+'项目研究开发设计书',
                                    url: '',
                                    fileName: ''
                                }
                                fetchPostFile(global.constants.previewFile,params)
                                    .then(
                                        res=>{
                                            res.blob().then(
                                                blob=> {
                                                    let blobUrl = window.URL.createObjectURL(blob);
                                                    this.setState(()=>({
                                                        fileStream:blobUrl,
                                                        uploadFile_visible:false,
                                                        checkStatus:true,
                                                    }))
                                                })
                                        }
                                    )
                        }
                    })
        }
    }
    delete(){
        let params = {
            companyId:this.state.companyId,
            projectId:this.state.projectId,
            productId:0,
            patentId:0,
            otherId:0,
            remark:this.state.projectNameUpload+'项目研究开发设计书',
            url: '',
        }
        fetchPost(global.constants.deleteFile,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("删除成功").then()
                        this.setState(()=>({
                            checkStatus:false,
                        }))
                    }
                }
            )
    }
    handleChangeTabBar = (tabBar) => {
        this.setState({
            tabBar: tabBar
        })
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="项目研究开发设计书"
                        subTitle="立项报告可编辑生成或上传，只允许上传50M以内的pdf格式的文件"
                    >
                    </PageHeader>
                </div>
                <div>
                    <Paragraph>
                        <pre>注：若两种方式的文件均存在，文件合成时系统自动选取上传的文件。</pre>
                    </Paragraph>
                </div>
                <Menu
                    theme="light"
                    selectedKeys={[this.state.tabBar]}
                    mode="horizontal">
                    <Menu.Item key='1' onClick={this.handleChangeTabBar.bind(this, '1')} icon={<MailOutlined />}>
                       项目列表
                    </Menu.Item>
                    <Menu.Item key='2' onClick={this.handleChangeTabBar.bind(this, '2')} >
                        {this.state.projectName}
                    </Menu.Item>
                </Menu>
                {
                    this.state.tabBar === '1' &&(
                        <Space direction="vertical" className="content-style" >
                            <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                                <Table dataSource={this.state.project}>
                                    <Column align="center" title={<p className="list-column-style">序号</p>} width="80" render={(text,record,index)=>`${index+1}`}/>
                                    <Column align="center" title={<p className="list-column-style">项目名称</p>} dataIndex="projectName" key="projectName" />
                                    <Column
                                        align="center"
                                        title={<p className="list-column-style">操作</p>}
                                        key="action"
                                        render={(text, record) => (
                                            <Space size="middle">
                                                <Button
                                                    type="primary"
                                                    icon={<EditOutlined />}
                                                    onClick={this.handleEditClick.bind(this,record)}
                                                >编辑</Button>
                                                <Button
                                                    type="primary"
                                                    icon={<UploadOutlined />}
                                                    onClick={this.handleUploadClick.bind(this,record)}
                                                >上传</Button>
                                            </Space>
                                        )}
                                    />
                                </Table>
                            </Card>
                        </Space>
                    )
                }
                {
                    this.state.tabBar === '2' &&(
                        <div>
                        <Space direction="vertical" className="content-style1" >
                            <Anchor id="downloadDiv" style={{display: 'none'}}/>
                            <div>
                                <Button type="primary" className="upload-button" onClick={this.download.bind(this)}>下载</Button>
                                <Button type="primary" className="upload-button" onClick={this.handleExportClick.bind(this)}>生成</Button>
                                <Button className="upload-button" type="primary"  onClick={this.submit}>提交</Button>
                                <Button type="primary" className="upload-button" onClick={this.alter.bind(this)}>修改</Button>
                            </div>
                            <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                                <Typography >
                                    <div className='word-cover'>
                                        <Paragraph className='word-cover-title'>{this.state.companyName}研发项目立项计划书</Paragraph>
                                    </div>
                                    <Paragraph className='word-cover-1'>项目名称
                                        <h className='underline'>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            {this.state.projectName}
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </h>
                                    </Paragraph>
                                    <Paragraph className='word-cover-1'>项目编号
                                        <h className='underline'>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            {this.state.projectCode}
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </h>
                                    </Paragraph>
                                    <Paragraph className='word-cover-1'>承担部门
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            {
                                                this.state.status === false?
                                                    <Input className="input_style"
                                                           defaultValue={this.state.projectData.department}
                                                           onChange={this.departmentChange.bind(this)}/>:
                                                    <h className='underline'>
                                                        {this.state.projectData.department}
                                                    </h>
                                            }
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </Paragraph>
                                    <Paragraph className='word-cover-1'>项目负责人
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            {
                                                this.state.status === false?
                                                    <Input className="input_style"
                                                           defaultValue={this.state.projectData.person}
                                                           onChange={this.personChange.bind(this)}/>:
                                                    <h className='underline'>
                                                        {this.state.projectData.person}
                                                    </h>
                                            }
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </Paragraph>
                                    <Paragraph className='word-cover-1'>项目起止时间
                                        <h className='underline'>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            {this.state.startTime}-{this.state.endTime}
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </h>
                                    </Paragraph>
                                    <div style={{float:'right',marginRight:'10%'}}>
                                        <Paragraph className='word-cover-2'>公司名称:{this.state.companyName}</Paragraph>
                                        <Paragraph className='word-cover-2'>日期:
                                            {
                                                this.state.status === false?
                                                    <Space direction="vertical" size={12}>
                                                            <DatePicker
                                                                className="datePicker"
                                                                picker="month"
                                                                defaultValue={
                                                                    moment(
                                                                        this.state.projectData.time === null?
                                                                            this.state.projectData.time:'2020年08月','YYYY年MM月')} //默认值要求moment格式
                                                                format={'YYYY年MM月'}
                                                                onChange={this.timeChange.bind(this)}
                                                            />
                                                    </Space>
                                                    :
                                                    this.state.projectData.time
                                            }
                                        </Paragraph>
                                    </div>
                                </Typography>
                            </Card>
                        </Space>
                        <Space direction="vertical" className="content-style1" >
                            <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                            <div className='title-style'>一、项目基本情况及时间安排</div>
                                <table border="1" className='table'>
                                    <tr>
                                        <td height="60;" colSpan="1" width="118px"  align='center'>项目名称</td>
                                        <td colSpan="5"  align='center' style={{padding:'10px'}}>{this.state.projectName}的研发</td>
                                    </tr>
                                    <tr>
                                        <td height="60;" colSpan="1" width="118px" align='center'>承担部门</td>
                                        <td colSpan="5"  align='center' style={{padding:'10px'}}>
                                    {
                                        this.state.status === false? this.state.department: this.state.projectData.department
                                    }
                                        </td>
                                    </tr>
                                <tr>
                                <td height="60;" colSpan="1" width="118px"  align='center'>技术来源</td>
                                        <td colSpan="5"  align='center' style={{padding:'10px'}}>
                                    {
                                        this.state.status === false?
                                        <Input className="input_style"
                                        defaultValue={this.state.projectData.parameter2}
                                        onChange={this.parameter2Change.bind(this)}/>:
                                        this.state.projectData.parameter2
                                    }
                                        </td>
                                </tr>
                                <tr>
                                    <td height="60;" colSpan="1" width="118px"  align='center'>项目组主要研究人员</td>
                                    <td colSpan="2"  align='center' style={{padding:'10px'}}>
                                        {
                                            this.state.status === false?
                                            <Input className="input_style"
                                            defaultValue={this.state.projectData.parameter3}
                                            onChange={this.parameter3Change.bind(this)}/>:
                                            this.state.projectData.parameter3
                                        }
                                    </td>
                                    <td height="60;" colSpan="1" width="118px"  align='center'>研发人员姓名</td>
                                    <td colSpan="2"  align='center' style={{padding:'10px'}}>
                                        {
                                            this.state.status === false?
                                            <Input className="input_style"
                                            defaultValue={this.state.projectData.parameter4}
                                            onChange={this.parameter4Change.bind(this)}/>:
                                            this.state.projectData.parameter4
                                        }
                                    </td>
                                </tr>
                                <tr>
                                <td height="60;" colSpan="6" width="118px"  align='center'>项目计划进度安排</td>
                                </tr>
                                <tr>
                                <td height="60;" colSpan="2" width="118px"  align='center'>时间安排</td>
                                <td height="60;" colSpan="4" width="118px"  align='center'>进度安排</td>
                                </tr>
                                <tr>
                                <td height="60;" colSpan="2" width="118px" align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <Input className="input_style"
                                defaultValue={this.state.projectData.parameter5}
                                onChange={this.parameter5Change.bind(this)}/>:
                                this.state.projectData.parameter5
                            }
                                </td>
                                <td height="60;" colSpan="4" width="118px"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea
                                   autoSize={{ minRows: 1, maxRows: 3 }}
                                   defaultValue={this.state.projectData.parameter6}
                                   onChange={this.parameter6Change.bind(this)}/>:
                                this.state.projectData.parameter6
                            }
                                </td>
                                </tr>
                                <tr>
                                <td height="60;" colSpan="2" width="118px"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <Input className="input_style"
                                defaultValue={this.state.projectData.parameter7}
                                onChange={this.parameter7Change.bind(this)}/>:
                                this.state.projectData.parameter7
                            }
                                </td>
                                <td height="60;" colSpan="4" width="118px"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea  autoSize={{ minRows: 1, maxRows: 3 }}
                                defaultValue={this.state.projectData.parameter8}
                                onChange={this.parameter8Change.bind(this)}/>:
                                this.state.projectData.parameter8
                            }
                                </td>
                                </tr>
                                <tr>
                                <td height="60;" colSpan="2" width="118px"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <Input className="input_style"
                                defaultValue={this.state.projectData.parameter9}
                                onChange={this.parameter9Change.bind(this)}/>:
                                this.state.projectData.parameter9
                            }
                                </td>
                                <td height="60;" colSpan="4" width="118px"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea autoSize={{ minRows: 1, maxRows: 3 }}
                                defaultValue={this.state.projectData.parameter10}
                                onChange={this.parameter10Change.bind(this)}/>:
                                this.state.projectData.parameter10
                            }
                                </td>
                                </tr>
                                <tr>
                                <td height="60;" colSpan="2" width="118px"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <Input className="input_style"
                                defaultValue={this.state.projectData.parameter11}
                                onChange={this.parameter11Change.bind(this)}/>:
                                this.state.projectData.parameter11
                            }
                                </td>
                                <td height="60;" colSpan="4" width="118px"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea autoSize={{ minRows: 1, maxRows: 3 }}
                                defaultValue={this.state.projectData.parameter12}
                                onChange={this.parameter12Change.bind(this)}/>:
                                this.state.projectData.parameter12
                            }
                                </td>
                                </tr>
                                <tr>
                                <td height="60;" colSpan="2" width="118px"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <Input className="input_style"
                                defaultValue={this.state.projectData.parameter13}
                                onChange={this.parameter13Change.bind(this)}/>:
                                this.state.projectData.parameter13
                            }
                                </td>
                                <td height="60;" colSpan="4" width="118px"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea autoSize={{ minRows: 1, maxRows: 3 }}
                                defaultValue={this.state.projectData.parameter14}
                                onChange={this.parameter14Change.bind(this)}/>:
                                this.state.projectData.parameter14
                            }
                                </td>
                                </tr>
                                </table>
                                <div className='title-style'>二、立项目的及组织实施方式</div>
                                <table border="1" className='table'>
                                <tr>
                                <td height="100;" colSpan="1" width="118px"  align='center'>立项目的</td>
                                <td colSpan="5"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea
                                defaultValue={this.state.projectData.parameter15}
                                onChange={this.parameter15Change.bind(this)}
                                width={'40%'}
                                autoSize={{ minRows: 3, maxRows: 6 }}
                                />:
                                this.state.projectData.parameter15
                            }
                                </td>
                                </tr>
                                <tr>
                                <td height="100;" colSpan="1" width="118px"  align='center'>组织实施方式</td>
                                <td colSpan="5"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea
                                defaultValue={this.state.projectData.parameter16}
                                onChange={this.parameter16Change.bind(this)}
                                width={'40%'}
                                autoSize={{ minRows: 3, maxRows: 6 }}
                                />:
                                this.state.projectData.parameter16
                            }
                                </td>
                                </tr>
                                </table>
                                <div className='title-style'>三、研发项目预期目标</div>
                                <table border="1" className='table'>
                                <tr>
                                <td height="100;" colSpan="1" width="118px"  align='center'>拟解决的关键问题</td>
                                <td colSpan="5"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea
                                defaultValue={this.state.projectData.parameter17}
                                onChange={this.parameter17Change.bind(this)}
                                width={'40%'}
                                autoSize={{ minRows: 3, maxRows: 6 }}/>:
                                this.state.projectData.parameter17
                            }
                                </td>
                                </tr>
                                <tr>
                                <td height="100;" colSpan="1" width="118px"  align='center'>拟采用技术方案</td>
                                <td colSpan="5"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea
                                defaultValue={this.state.projectData.parameter18}
                                onChange={this.parameter18Change.bind(this)}
                                width={'40%'}
                                autoSize={{ minRows: 3, maxRows: 6 }}
                                />:
                                this.state.projectData.parameter18
                            }
                                </td>
                                </tr>
                                <tr>
                                <td height="100;" colSpan="1" width="118px"  align='center'>预计形成的主要技术成果</td>
                                <td colSpan="5"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea
                                defaultValue={this.state.projectData.parameter19}
                                onChange={this.parameter19Change.bind(this)}
                                width={'40%'}
                                autoSize={{ minRows: 3, maxRows: 6 }}/>:
                                this.state.projectData.parameter19
                            }
                                </td>
                                </tr>
                                <tr>
                                <td height="100;" colSpan="1" width="118px"  align='center'>知识产权归属及保护措施</td>
                                <td colSpan="5"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea
                                defaultValue={this.state.projectData.parameter20}
                                onChange={this.parameter20Change.bind(this)}
                                width={'40%'}
                                autoSize={{ minRows: 3, maxRows: 6 }}/>:
                                this.state.projectData.parameter20
                            }
                                </td>
                                </tr>
                                </table>
                                <div className='title-style'>四、研发投入及效益预测</div>
                                <table border="1" className='table'>
                                <tr>
                                <td height="100;" colSpan="1" width="118px"  align='center'>研究开发费用预算</td>
                                <td colSpan="5"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea
                                defaultValue={this.state.projectData.parameter21}
                                onChange={this.parameter21Change.bind(this)}
                                width={'40%'}
                                autoSize={{ minRows: 3, maxRows: 6 }}/>:
                                this.state.projectData.parameter21
                            }
                                </td>
                                </tr>
                                <tr>
                                <td height="100;" colSpan="1" width="118px"  align='center'>总经理意见</td>
                                <td colSpan="5"  align='center' style={{padding:'10px'}}>
                            {
                                this.state.status === false?
                                <TextArea
                                defaultValue={this.state.projectData.parameter22}
                                onChange={this.parameter22Change.bind(this)}
                                width={'40%'}
                                autoSize={{ minRows: 3, maxRows: 6 }}/>:
                                this.state.projectData.parameter22
                            }
                                </td>
                                </tr>
                                </table>
                            </Card>
                    </Space>
                </div>
                    )
                }
                <Modal
                    visible={this.state.upload_visible}
                    title={'上传附件'}
                    onCancel={this.hideModal.bind(this)}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal.bind(this)}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.hideModal.bind(this)}>
                            完成
                        </Button>,
                    ]}
                >
                    <div>
                       该项目的项目研究开发设计书
                        {this.state.checkStatus === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                        <Form style={{marginTop:'20px'}}>
                            <Form.Item
                                name='file'
                                method="post"
                                enctype="multipart/form-data"
                            >
                                <input
                                    type="file"
                                    name='file'
                                    onChange={this.fileInput.bind(this)}
                                />
                            </Form.Item>
                            <Form.Item name="preview_paper">
                                {
                                    this.state.checkStatus === true &&
                                        <div>
                                            <Button type={"primary"} onClick={this.delete.bind(this)}>删除</Button>
                                            <FileViewer fileType='pdf'
                                                        filePath={this.state.fileStream}
                                                        onError={this.onError}
                                            />
                                        </div>
                                }
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
                <Modal
                    visible={this.state.uploadFile_visible}
                    title={'上传'}
                    onCancel={this.hideModalTwo.bind(this)}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModalTwo.bind(this)}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.uploadFile.bind(this)}>
                            确定
                        </Button>,
                    ]}
                >
                    <div>确定上传该项目研究开发设计书吗？</div>
                </Modal>
            </div>
        )
    }
    departmentChange(e){
        const value = e.target.value
        this.setState(()=>({
            department:value
        }))
    }
    personChange(e){
        const value = e.target.value
        this.setState(()=>({
            person:value
        }))
    }
    timeChange(value,DateString){
        this.setState(()=>({
            time:DateString
        }))
    }
    parameter2Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter2:value
        }))
    }
    parameter3Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter3:value
        }))
    }
    parameter4Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter4:value
        }))
    }
    parameter5Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter5:value
        }))
    }
    parameter6Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter6:value
        }))
    }
    parameter7Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter7:value
        }))
    }
    parameter8Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter8:value
        }))
    }
    parameter9Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter9:value
        }))
    }
    parameter10Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter10:value
        }))
    }
    parameter11Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter11:value
        }))
    }
    parameter12Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter12:value
        }))
    }
    parameter13Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter13:value
        }))
    }
    parameter14Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter14:value
        }))
    }
    parameter15Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter15:value
        }))
    }
    parameter16Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter16:value
        }))
    }
    parameter17Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter17:value
        }))
    }
    parameter18Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter18:value
        }))
    }
    parameter19Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter19:value
        }))
    }
    parameter20Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter20:value
        }))
    }
    parameter21Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter21:value
        }))
    }
    parameter22Change(e){
        const value = e.target.value
        this.setState(()=>({
            parameter22:value
        }))
    }

}

export default ProjectReport;